document.addEventListener("DOMContentLoaded", function () {
  // code for accordion
  $(".accordion_head").click(function (event) {
    event.stopPropagation();

    const $this = $(this);
    const $parent = $this.parent();
    const $accordionContainer = $parent.parent();
    const duration = 300;

    $accordionContainer
      .find(".accordion_head")
      .not($this)
      .removeClass("activeHead");
    $accordionContainer
      .find(".accordion_body")
      .not($parent.find(".accordion_body"))
      .slideUp(duration);

    $this.toggleClass("activeHead");
    $parent.find(".accordion_body").slideToggle(duration);
    setTimeout(() => {
      if ($this.hasClass("scrollToTop")) {
        const targetSection = $parent;
        const navbarHeight = $(".full-header").outerHeight();
        const targetPosition = targetSection.offset().top - navbarHeight - 80;
        const startPosition = $(window).scrollTop();
        // You can adjust the scrolling speed here (in milliseconds)
        const duration = 200;
  
        $("html, body").animate(
          {
            scrollTop: targetPosition,
          },
          duration
        );
      }
    }, 500);
  });

  // code for images getting blurred on load

  class BlurredImageLoader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.blurredImageDivs = this.querySelectorAll(".blurred-img");
      this.loaded = this.loaded.bind(this);

      this.blurredImageDivs.forEach((div) => {
        const img = div.querySelector("img");

        if (img) {
          if (img.complete) {
            this.loaded(div);
          } else {
            img.addEventListener("load", () => this.loaded(div));
          }
        }
      });
    }

    loaded(div) {
      div.classList.add("loaded");
    }
  }

  customElements.define("blurred-image-loader", BlurredImageLoader);

  // BREADCRUMB BACK BUTTON
  const backBtn = document.querySelector(".back-btn-wrap");
  if (backBtn) {
    backBtn.addEventListener("click", function () {
      window.history.back();
    });
  }

  // 3D model viewer

  const $body = $("body");
  $("body").on("click", ".three-d-btn", function () {
    open3DModel($(this));
  });

  $("body").on("click", ".close-three-d-model", function () {
    close3DModel($(this));
  });

  function open3DModel($this) {
    const $threeDModel = $this.closest(".product-media").find(".three-d-model");
    const $threeDModelIframe = $threeDModel.find("iframe");

    $threeDModelIframe.attr("src", $this.data("src"));
    $threeDModel.removeClass("hidden");
    $body.addClass("overflow-hidden");
  }

  function close3DModel($this) {
    const $threeDModel = $this.closest(".product-media").find(".three-d-model");
    const $threeDModelIframe = $threeDModel.find("iframe");

    $threeDModel.addClass("hidden");
    $threeDModelIframe.attr("src", "");
    $body.removeClass("overflow-hidden");
  }

  // code for info drawer

  const $infoContainer = $(".info-container");
  const $infoDrawer = $(".info-drawer");
  const $closeInfoDrawer = $(".close-info-drawer");

  $("body").on("click", ".open-info-drawer", function () {
    openInfoDrawer();
  });

  $closeInfoDrawer.on("click", function () {
    closeInfoDrawer();
  });

  function openInfoDrawer() {
    $infoContainer.addClass("info-drawer-enabled");
    $infoDrawer.removeClass("translate-x-full").addClass("translate-x-0");
    $body.addClass("overflow-hidden");
  }

  function closeInfoDrawer() {
    $infoContainer.removeClass("info-drawer-enabled");
    $infoDrawer.removeClass("translate-x-0").addClass("translate-x-full");
    $body.removeClass("overflow-hidden");
  }

  // custom slider for faq links
  $(".scrollLeftButton").click(function () {
    const $div = $(this).parent().find(".custom_js_slider");
    const windowWidth = $div.width();
    const scrollAmount = windowWidth * 0.5;
    $div.animate({ scrollLeft: "-=" + scrollAmount }, 100);
  });

  $(".scrollRightButton").click(function () {
    const $div = $(this).parent().find(".custom_js_slider");
    const windowWidth = $div.width();
    const scrollAmount = windowWidth * 0.5;
    $div.animate({ scrollLeft: "+=" + scrollAmount }, 100);
  });

  // KLAVIYO JS

  KlaviyoSubscribe.attachToForms(".klaviyo_newsletter_form", {
    hide_form_on_success: true,
    success_message:
      "Thanks for subscribing! Check your email for a confirmation message.",
    error_message: "Wrong email",
    extra_properties: {
      $source: "Newsletter Embed",
      language: Shopify.locale,
    },

    success: function ($form) {
      // `$form` is a jQuery wrapper around the form that was submitted. This makes it easy to get the email address or form fields.
      var email = $form.find('[name="email"]').val();
      klaviyo.push(["identify", { $email: email }]);
      klaviyo.push(["track", "Signed Up for Newsletter"]);
    },
  });

  // code for sticky add to cart PDP
  // Function to add the "come-in" class when the element is in view
  function handleIntersection(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && document.querySelector(".add-to-cart-sticky")) {
        // When the element is in view, add the "come-in" class
        document
          .querySelector(".add-to-cart-sticky")
          .classList.remove("come-in");
        // Stop observing after adding the class (optional)
        // observer.unobserve(entry.target);
      } else {
        if (document.querySelector(".add-to-cart-sticky")) {
          document.querySelector(".add-to-cart-sticky").classList.add("come-in");
        }
      }
    });
  }

  // Create an intersection observer instance
  const observer = new IntersectionObserver(handleIntersection, {
    // Root is set to null to observe the whole viewport
    root: null,
    // Set a threshold (0 to 1) for intersection ratio
    threshold: 0.2, // 20% of the element visible in the viewport will trigger the callback
  });

  // Get the element to observe
  const addToCartStickyElement = document.querySelector(
    ".quantity_addToCart-wrap"
  );
  if (addToCartStickyElement) {
    // Start observing the element
    observer.observe(addToCartStickyElement);
  }

  // code for filter drawer

  var allFilters = document.querySelectorAll(".all_filters");
  allFilters.forEach(function (filter) {
    filter.addEventListener("click", function () {
      var filterDrawer = document.querySelector(".all_filter_drawer");
      filterDrawer.classList.add("active_filterdrawer");
      document.body.classList.add("overflow-hidden");
    });
  });

  var closeFilters = document.querySelectorAll(".close_filterdrawer");
  closeFilters.forEach(function (closefilter) {
    closefilter.addEventListener("click", function () {
      var filterDrawer = document.querySelector(".all_filter_drawer");
      filterDrawer.classList.remove("active_filterdrawer");
      document.body.classList.remove("overflow-hidden");
    });
  });

// Discount code

  document.addEventListener("disCountAppliedEvent", function (d) {
    const details = d.detail;
    if (details.is_from_cookie === false) {
    }
    const $totalDiv = $(".total-price.totals .totals__subtotal-value");
    const $totalPrice = details.after_disc_total;
    $totalDiv.html($totalPrice);
  
    const newDiv = $('<div class="text-[#266435] italic ml-auto"></div>');
    newDiv.text(`-${details.discount_val}`);
    $(".discountify_status .cpn_dcnt_price").append(newDiv);
  });
  document.addEventListener("disCountRemovedEvent", function (d) {
    const details = d.detail;
    const $totalDiv = $(".total-price.totals .totals__subtotal-value");
    const $totalPrice = $(".total-price.totals .totals__subtotal-value").data(
      "total"
    );
    $totalDiv.html($totalPrice);
  });


});
